<template>
    <div id="mainFrame">
        <!-- 这里是从衣加加进来的header，不展示切换 -->
       <!-- <div class="header isYjj" v-if="!isShowToggleBtn">
            <div class="leftIcon" @click="back">
                <i class="el-icon-arrow-left"></i>
            </div>
            <span>{{title}}</span>
        </div> -->
        <!-- 这里是直接打开的header-->
        <div class="header" v-if="isShowToggleBtn">
            <img src="../../images/headerLogo.png" alt="" @click="goIndex" />
            <transition name="el-fade-in">
                <img src="../../images/newImages/home_ic_close.png" alt="" class="imgRight" @click="toggle" v-show="isShowSetting" />
            </transition>
            <transition name="el-fade-in">
                <img src="../../images/headerSettingIcon.png" alt="" class="imgRight" @click="toggle" v-show="!isShowSetting" />
            </transition>
            
            <el-collapse-transition>
                <div class="settingBox" v-show="isShowSetting">
                   <!-- <div class="telBox">
                        <a href="tel:0571-86221010"><i class="el-icon-phone"></i> 0571-86221010</a>
                    </div> -->
                    <ul class="settingUl">
                        <li v-for="(list,index) in settingOptions" :key="index"  @click="go(list.name)" :class="{active:list.name==pathName}">{{list.text}}</li>
                    </ul>
                </div>
            </el-collapse-transition>
            

        </div>
        <div class="mainContent_mainFrame" :class="{noMargin:!isShowToggleBtn}">
            <router-view />
        </div>

    </div>
</template>

<script>
    import {
        GetRequest
    } from '@/assets/common.js'
    export default {
        name: 'App',
        data() {
            return {
                settingOptions: [],
                isShowSetting: false,
                pathName: '',
                isShowToggleBtn: true,
                title: '',
            }
        },
        watch: {
            "$route": {
                handler: function(to, form) {
                    console.log("wacth")
                    console.log(to, 'to')
                    this.pathName = to.name
                },
                immediate: true
            },
        },
        methods: {
            back() {
                if (window.plus) {
                    var ws = plus.webview.currentWebview();
                    console.log(ws.id)
                    ws.close();
                } else {
                    this.$router.back()
                }

                // window.history.back()
            },
            goIndex() {
                this.isShowSetting=false
                this.$router.push("/")
            },
            go(url) {
                if(url==this.pathName){
                    this.$message({
                    	message:"已经是当前页面",
                    	duration: 1000,
                    });
                }else{
                     this.$router.push({
                        name: url
                    });
                    this.isShowSetting = false
                }
               
            },
            toggle() {
                this.isShowSetting = !this.isShowSetting
            }

        },
        mounted() {
            let _this = this
            let mainRoute = this.$router.options.routes
            //			this.$router.push({name:'Home'});
            mainRoute.forEach(function(item, index) {
                if (item.path.search("mainFrame") > -1) {
                    _this.settingOptions = item.children
                    console.log(_this.settingOptions)
                }
            })
            //判断title
            _this.settingOptions.forEach(function(item, index) {
                if (item.name == _this.pathName) {
                    _this.title = item.text
                }
            })
            // this.title=to.text

            //是否从衣加加过来
            this.paramObj = GetRequest()
            console.log(this.paramObj, 'mainframe里面的地址')
            if (this.paramObj.hidetoggle == 1) {
                this.isShowToggleBtn = false
                sessionStorage.setItem('isFromYjj',1)
                 console.log(sessionStorage.getItem('isFromYjj'),'是否来自衣加加')
            }

        }
    }
</script>

<style lang="less" scoped="scoped">
    .active {
        color: red;
    }

    /*头部下拉菜单*/

    .settingBox {
        position: absolute;
        top: 1.6rem;
        padding:0.17rem 0.4rem; width: 100%; left:0; box-sizing: border-box; background: #010512; opacity: 0.9;
        .settingUl {
            li {
                font-size: 0.36rem; line-height: 0.36rem; color:#fff; padding:0.4rem 0rem;text-align: center;
                border-bottom: 1px solid #fff;border-color:rgba(255,255,255,0.4)
            }
            li:last-child{border:none;}
            li:hover,li:active,li.active{color:red; cursor: pointer;opacity: 1;}
        }

        

        .telBox {
            padding: 0.16rem 0.24rem;
            text-align: center;
            border-bottom: 1px solid #ddd;
        }
    }

    body {
        background: #f7f7f7;
    }

    .header.isYjj {
        background: #f7f7f7;
        text-align: center;

        .leftIcon {
            position: absolute;
            left: 0.4rem;
            font-weight: bold;
            top: 0.34rem;
            padding: 10px;
        }

        .leftIcon:active {
            background: #ddd;
        }
    }

    .header {
        position: fixed;
        z-index:1000;
        top: 0;
        left: 0;
        right: 0;
        padding:0 0.4rem;
        padding-top: 0.6rem;
        background: #F9FAFB;
        font-size: 0.32rem;
        padding-bottom:0.56rem;
        img {
            height: 0.44rem;
        }

        .imgRight {
            height: 0.6rem;
            width: 0.6rem;
            position: absolute;
            right: 0.28rem;
            top: 0.56rem;
        }
    }

    .mainContent_mainFrame {
        margin-top:1.6rem;
    }
    .noMargin.mainContent_mainFrame {
        margin-top: 0;
    }
</style>



// WEBPACK FOOTER //
// src/page/introPage/mainFrame.vue